"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumber = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("@/app/shared/components");
const constants_1 = require("@/app/shared/constants");
const helpers_1 = require("@/app/shared/helpers");
const dropdown_1 = require("primereact/dropdown");
const PhoneNumber = ({ countryCode, phoneNumber, placeholder, disabled, invalid, handleChangeCode, handleChangePhone, }) => {
    const handleCountryCodeChange = (event) => {
        if (!event.target.value)
            return;
        handleChangeCode?.(event.target.value);
    };
    const localPhoneChangeHandle = (value) => {
        const phone = value.trim();
        // to prevent autocomplete with incorrect values
        if (/^([\d-])*$/.test(phone) && phone.length <= constants_1.MAX_LENGTH_PHONE) {
            handleChangePhone?.(phone);
        }
    };
    const timeFormatTemplate = (option) => {
        return option && (0, jsx_runtime_1.jsx)("div", { children: `${option.name} ${option.phoneCode}` });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'flex gap-8px', children: [(0, jsx_runtime_1.jsx)("div", { className: 'flex-none', children: (0, jsx_runtime_1.jsx)(dropdown_1.Dropdown, { value: (0, helpers_1.getCountryDataByCode)(countryCode), onChange: handleCountryCodeChange, options: helpers_1.COUNTRY_LIST, optionLabel: 'name', optionValue: 'code', useOptionAsValue: true, valueTemplate: timeFormatTemplate, itemTemplate: timeFormatTemplate, disabled: disabled, filter: true, filterBy: 'search', className: 'dropdown-sm' }) }), (0, jsx_runtime_1.jsx)("div", { className: 'flex-1', children: (0, jsx_runtime_1.jsx)(components_1.InputText, { className: 'w-full', keyfilter: 'int' // support digits and -
                    , value: phoneNumber, placeholder: placeholder, onDelayChange: localPhoneChangeHandle, disabled: disabled, maxLength: constants_1.MAX_LENGTH_PHONE, invalid: invalid }) })] }));
};
exports.PhoneNumber = PhoneNumber;
